import React, { useState } from 'react';
import { Card, CardContent, Avatar, Typography, Grid, BoxGrid, Box, InputBase } from '@mui/material';
import {useNavigate,useSearchParams} from "react-router-dom"
import SearchIcon from "@mui/icons-material/Search";

const conversations = [
  { id: 1, name: 'Yaroslav Zubko', message: 'It is a long Ipsum available ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 2, name: 'Yaroslav Zubko', message: 'Grateful thoughts...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 3, name: 'Justas Galaburda', message: 'It is a long Ipsum available ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 4, name: 'Charles Patterson', message: 'OK, Thanks', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 5, name: 'Yaroslav Zubko', message: 'It is a long Ipsum available ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
  { id: 6, name: 'Invision Inc', message: 'We own Hidden Lake ...', avatar: 'https://tse1.mm.bing.net/th?id=OIP.qocnTczJTRMg-ZrYcwS4zAHaHa&pid=Api&P=0&h=180' },
];

const MessageSidebar = ({isSideBar,setIsSideBar,recentChat=[]}) => {
  const [activeTab, setActiveTab] = useState('all');
  const navigate=useNavigate()
  const [searchParams] = useSearchParams();


  const handleConverstaionClick=(userId)=>{

    const currentParams = Object.fromEntries(searchParams.entries());

    // Add or update query parameters
    const updatedParams = {
      ...currentParams,
      chatId: 12555,
      userId: userId,
    };

    // Convert the updated params object to a query string
    const queryString = new URLSearchParams(updatedParams).toString();

    // Navigate to the new URL with the updated query params
    navigate(`?${queryString}`);


  setIsSideBar(false)
  }

  return (
 <>

<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, borderBottom: '2px solid #e0e0e0',minWidth:"250px" ,overflow:"hidden"}}>
      <Box
      sx={{
        maxWidth: "100%",
       my:1,
       px:2
     
      }}
    >
      <Grid container direction="column" spacing={2}>
        {/* Title */}
        <Grid item>
          <Typography
            variant="h5"
            sx={{ fontWeight: "600", fontSize: "18px", color: "#000" }}
          >
            Inbox
          </Typography>
        </Grid>

        {/* Search Bar */}
        <Grid item>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              background: "white",
              padding: "8px 12px",
              borderRadius: "8px",
              border: "1px solid #E0E0E0",
              width:"120%"
            }}
          >
            <SearchIcon sx={{ color: "#B0B0B0",bgcolor:"white", marginRight: "8px" }} />
            <InputBase
              placeholder="Search for users"
              sx={{
                fontSize: "14px",
                flex: 1,
                color: "#666",
                bgcolor:"white"
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
      </Box>

<Box sx={{ width: "100%", bgcolor: 'background.paper', borderRight: '1px solid #e0e0e0', height: '100%',maxHeight:"100%",overflowY:'auto', p: 2 }}>
      {/* Tabs */}
      

      {/* Conversations List */}
      <Box>
        {recentChat.map((conversation) => (
          <Card key={conversation.id}  onClick={e=>handleConverstaionClick(conversation._id)} sx={{ mb: 1, boxShadow: 'none', borderRadius: 0,minWidth:"250px" ,cursor:"pointer",overflow:"hidden"}}>
            <CardContent sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
              <Avatar src={conversation.profileImage} alt={conversation.firstName + " "+conversation.lastName} sx={{ mr: 2 }} />
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: '500' }}>
                  {conversation.firstName + " "+conversation.lastName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {conversation.lastName}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
 </>
  );
};

export default MessageSidebar;
